/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveBoxIcon24Solid = forwardRef('ArchiveBoxIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M2 4.5A1.5 1.5 0 0 1 3.5 3h17A1.5 1.5 0 0 1 22 4.5v2A1.5 1.5 0 0 1 20.5 8h-17A1.5 1.5 0 0 1 2 6.5v-2Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 9h18v9.5a3.5 3.5 0 0 1-3.5 3.5h-11A3.5 3.5 0 0 1 3 18.5V9Zm6 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z" })));
});
